import React, {Component} from "react"
import styled from "styled-components"
import get from "lodash/get"
import {Voucher} from "@irati/deals/types"
import {Auth} from "@irati/auth/types"
import {DealExternalLinks} from "@irati/types"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"

import withAuth from "@irati/auth/helpers/auth/withAuth"
import {ButtonLink} from "@irati/ui/src/Link"
import Hr from "@irati/ui/src/Layout/Hr"
import UrlSVG from "@irati/ui/images/url_icon.svg"
import PdfSVG from "@irati/ui/images/pdf_icon.svg"
import {H4} from "@irati/ui/src/Typography"
import {getPronounFromGender} from "@irati/identity/helpers/user/getPronounFromGender"
import {injectIntl, FormattedMessage, FormattedDate, InjectIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/perks/perks"
import id from "@irati/utils/id"
import StockType from "@irati/stock/enums/StockType"

import LabelValue from "./LabelValue"
import TicketContainer from "./styled/TicketContainer"

const TicketUrl = styled.div`
  position: relative;
  min-height: 50px;
  margin-bottom: 7px;
  display: inline-flex;
  align-items: center;
`

const Pin = styled(LabelValue)`
  margin-bottom: 3px;
`

interface Props extends InjectIntl {
  voucher: Voucher
  auth: Auth
  formatMessage: FormatMessage
  redemptionId: string
  externalLinks?: DealExternalLinks
}

export class DealSuccessTicketUrl extends Component<Props> {
  constructor(props) {
    super(props)
    this.state = {
      voucher: {...props.voucher, code: this.replaceTags(props.voucher.code)}
    }
  }

  getIcon = (voucher) => {
    if (voucher.type === StockType.PDF) {
      return PdfSVG
    }

    return UrlSVG
  }

  getButton = (additionalProps) => {
    const {type, code, deal} = this.state.voucher
    const url = type === StockType.URL
    const pdf = type === StockType.PDF

    return (
      <ButtonLink primary full href={code} target="_blank" onClick={() => tracking.redeemPerkFollowLink(deal)} {...additionalProps}>
        <FormattedMessage
          id={url || pdf ? "perks.components.tickets.ticket.url.open" : "perks.components.tickets.ticket.url.viewTicket"}
        />
      </ButtonLink>
    )
  }

  replaceTags = (code) => {
    const {auth, redemptionId} = this.props
    const {user} = auth

    return code
      .replace(/(\[user_uuid\])/, get(user, "id"))
      .replace(/(\[first_name\])/, get(user, "firstname") || "")
      .replace(/(\[last_name\])/, get(user, "lastname") || "")
      .replace(/(\[pronoun\])/, getPronounFromGender(get(user, "gender")))
      .replace(/(\[phone\])/, get(user, "phone"))
      .replace(/(\[email\])/, get(user, "email"))
      .replace(/(\[tenant\])/, get(user, "tenant"))
      .replace(/(\[redemption\])/, redemptionId)
  }

  render() {
    const {voucher} = this.state
    const {formatMessage, externalLinks} = this.props
    const {expiry, pin, product} = voucher
    const urlLabel = product?.name || (voucher.type === "URL" && formatMessage({id: "perks.components.tickets.ticket.url.discount"}))
    return (
      <TicketContainer className="ticket" id={id("url", this.props)}>
        <TicketUrl id="ticket_url">
          <img alt="url" src={this.getIcon(voucher)} />
          {urlLabel && (
            <H4 display="inline-block" paddingLeft={2}>
              {urlLabel}
            </H4>
          )}
        </TicketUrl>
        {pin && <Pin value={pin} label={formatMessage({id: "perks.components.tickets.ticket.url.PIN"})} />}
        {expiry && (
          <LabelValue
            value={<FormattedDate value={expiry} year="numeric" month="2-digit" day="numeric" />}
            label={formatMessage({id: "perks.components.tickets.ticket.url.expiryDate"})}
          />
        )}
        <Hr />
        {this.getButton()}
        {externalLinks?.web && (
          <ButtonLink
            marginTop={2}
            secondary
            full
            href={externalLinks.web}
            target="_blank"
            onClick={() => tracking.clickGiftCardSite(externalLinks.web)}>
            <FormattedMessage id="perks.components.tickets.ticket.visitSite" />
          </ButtonLink>
        )}
      </TicketContainer>
    )
  }
}

export default injectIntl(withAuth(DealSuccessTicketUrl))
